module.exports = {
  apiUrl:'https://staging.design.unirac.com',
  domainName :'unirac.com',
  forgotPasswordLink:'https://staging.design.unirac.com/forgotpassword'
};
